module.exports = require("./as");